// Phone validation — mirrors the employee-service input rule (validate_tz_phone):
// accepts local (0748015264) and international (+255748015264) forms, tolerating
// spaces, dashes and parentheses. The client must never be stricter than the
// backend it submits to — real client data is full of local-format numbers.
const PHONE = /^\+?\d{9,15}$/;

export const PHONE_PLACEHOLDER = '+255712345678';
export const PHONE_HINT = 'Enter a valid phone number, e.g. 0712345678 or +255712345678';

/** Strip formatting so "+255 712-345-678" validates the same as "+255712345678". */
export const normalizePhone = (v: string): string => (v || '').replace(/[\s().-]/g, '');

export const isValidPhone = (v: string): boolean => PHONE.test(normalizePhone(v));
